// #region Enums
import {
  modeRegisterEnum,
} from '@/enum/registers.enum';
// #endregion

/**
 * Vuex module to manage the APP
 */

const state = () => ({
  mode: modeRegisterEnum.DEFAULT,
});

const actions = {
  async changeMode({commit}, mode) {
    commit('SET_MODE_REGISTER', mode);
  },
};

const mutations = {
  /**
   * Sets mode register in the state.
   * @param {Object} state - Vuex state.
   * @param {string} mode - The new mode to set.
   */
  SET_MODE_REGISTER(state, mode) {
    state.mode = mode;
  },
};

const getters = {

  /**
   * Get the current mode register.
   * @param {Object} state - Vuex state.
   * @returns {string} - The current mode register.
   */
  getMode(state) {
    return state.mode;
  },

  /**
   * Check if the current mode is tutorize
   * @param {Object} state - Vuex state.
   * @returns {boolean} - True if the current mode is tutorize.
   */
  isTutorizeMode(state) {
    return state.mode === modeRegisterEnum.TUTORIZE;
  },
};

const namespaced = true;

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
